import React, { useState, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { AppBar } from 'components/Layout';
import Login from './login/login';
import { api, get } from 'communication/httpClient';
import AppLoader from './AppLoader';

const csrf = async () => {
  const response = await get('/api/csrf/csrfToken');
  const { data: { token: dataToken = '' } = {} } = response || {};

  api.defaults.headers.post['X-CSRF-TOKEN'] = dataToken;
  api.defaults.headers.put['X-CSRF-TOKEN'] = dataToken;
  api.defaults.headers.patch['X-CSRF-TOKEN'] = dataToken;
  api.defaults.headers.delete['X-CSRF-TOKEN'] = dataToken;
};

const Secure = ({ component: Component, ...rest }) => {
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      await csrf();
      const response = await get('/api/principal');
      setLoading(false);
      setLoggedIn(response.data);
    };
    fetch();
  }, []);

  if (loading) return <AppLoader />;
  return (
    <Route
      {...rest}
      render={(props) =>
        loggedIn ? (
          <>
            <AppBar setLoggedIn={setLoggedIn} />
            <Component {...props} />
          </>
        ) : (
          <Login />
        )
      }
    />
  );
};

export default Secure;
